import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';
import type {RawApiResponse} from 'api/api.types';
import {
    type MonthlyInventory,
    type TransientInventory,
} from 'api/inventory/inventory.types';

interface GetOperatorInventoryResponse {
    transient: TransientInventory;
    monthlyRecurring: MonthlyInventory;
    monthlyNonRecurring: MonthlyInventory;
}

type GetOperatorInventoryRawResponse =
    RawApiResponse<GetOperatorInventoryResponse>;

/**
 * Converts the keys of the Response object from snake_case to camelCase
 *
 * @param response
 *
 * @group DTO Formatters
 */
const formatOperatorInventoryResponse = (response: {
    data: GetOperatorInventoryRawResponse;
}) => {
    const formattedResponse = camelizeKeys(response.data);

    return formattedResponse;
};

/**
 * Gets the operator inventory for a given facility
 *
 * @param facilityId
 * @throws {Error}
 *
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/get_facilities_facility_id_operator_inventory
 * @see '/api/v1/facilities/{facilityId}/operator-inventory/'
 */
const getAllOperatorInventory = async (facilityId: number) => {
    try {
        const response = await spotheroGet<GetOperatorInventoryRawResponse>(
            `facilities/${facilityId}/operator-inventory/`
        );

        const formattedResponse = formatOperatorInventoryResponse(
            response.data
        );

        return formattedResponse;
    } catch (err) {
        sendSentryException(err);

        throw err;
    }
};

export default getAllOperatorInventory;
